module.exports = __webpack_public_path__ + "img/zhuozi_dyzt.a7750522.png";